import SubProcess from './SubProcess';

export default class Process {
    public id: number = 0;

    public processName: string = '';

    public subProcesses: Array<SubProcess> = [];

    public extendOuter: boolean = false;

    public fill: string = 'none';

    public stroke: string = '#111';

    public highlight: boolean = false;

    // constructor(data: any) {
    //   this.id = data.id;
    //   this.processName = data.processName;
    // }

    constructor(obj: any) {
        obj && Object.assign(this, obj);
    }

    async addSubProcess(subProcess: SubProcess) {
      subProcess.id = this.subProcesses.length + 1;
      this.subProcesses.push(subProcess);
    }

    withDefinedColors(fill: string, stroke: string): Process {
      this.fill = fill;
      this.stroke = stroke;
      return this;
    }
}
